// extracted by mini-css-extract-plugin
module.exports = {"pro-tip":"AccountExpiredModal__pro-tip__1S_r9","modal-copy":"AccountExpiredModal__modal-copy__1IQmQ","buy-button-wrapper":"AccountExpiredModal__buy-button-wrapper__F0iFz"};